import { Route } from '@angular/router';
import { HomePageComponent } from './home-page/home-page.component';
import { forcedLoginGuard } from '@lyceo/shared/auth/feature-main';
import { DirectLinkPageComponent } from './direct-link-page/direct-link-page.component';
import { DirectLinkSessionPageComponent } from './direct-link-session-page/direct-link-session-page.component';
import { NotFoundPageComponent } from '@lyceo/shared/not-found/feature-main';

export const appRoutes: Route[] = [
  {
    path: 'home',
    component: HomePageComponent,
    canActivate: [forcedLoginGuard()],
  },
  {
    path: 'start/:directLink',
    component: DirectLinkPageComponent,
  },
  {
    path: 'start/session/:directLinkSessionId',
    component: DirectLinkSessionPageComponent,
  },
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: '**',
    component: NotFoundPageComponent,
  },
];
